<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KKovUB/tc-custom/9780253005281.jpg?1721453851196" alt="This image is the cover for the book Performer's Guide to Seventeenth-Century Music, Publications of the Early Music Institute"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Performer's Guide to Seventeenth-Century Music, Publications of the Early Music Institute
      </h1>
      <p class="bookDescription body article font2">
        <p>Revised and expanded, A Performer's Guide to Seventeenth Century Music is a comprehensive reference guide for students and professional musicians. The book contains useful material on vocal and choral music and style; instrumentation; performance practice; ornamentation, tuning, temperament; meter and tempo; basso continuo; dance; theatrical production; and much more. The volume includes new chapters on the violin, the violoncello and violone, and the trombone—as well as updated and expanded reference materials, internet resources, and other newly available material. This highly accessible handbook will prove a welcome reference for any musician or singer interested in historically informed performance.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stewart Carter, Jeffery Kite-Powell
      </h2>
      
      <p class="authorDescription body article"><P>Jeffery Kite-Powell is Professor Emeritus at the Florida State University College of Music. He is translator of Michael Praetorius's Syntagma Musicum III and editor of A Performer's Guide to Renaissance Music, Second Edition (IUP, 2007).</P><P>Stewart Carter is Chair of the Department of Music at Wake Forest University, Executive Editor of the Historic Brass Society Journal, and former Editor of Historical Performance: The Journal of Early Music America.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?362d3a83